import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class CreatePointPaidPositionDto {
  @Expose()
  name: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  monthlySalary: number;

  @Expose()
  averagePoints: number;
}
